/**
 * It returns the AuthContext object from the useContext hook
 */
import { useContext } from 'react';
import { AuthContext } from '../contexts/auth-context';
// eslint-disable-next-line
export const useAuth = () => useContext(AuthContext) as any;
